import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLanguage } from '../../../hooks';
// import PromoAdWide from '../../../img/welcome/home/promo-ad-wide.png';
import { setCredentials } from '../../../services/api';
import { Adverts, Banner, MediaProduct, MediaUnit, News, NotificationUnit, Polls, ProductUnit, Promo, TVUnit, useGetPublicBlocksQuery } from '../../../services/content_v1';
import WelcomeAdBanner from './WelcomeAdBanner';
import WelcomeAuth from './WelcomeAuth';
import WelcomeBanners from './WelcomeBanners';
import WelcomeBottom from './WelcomeBottom';
import WelcomeContent from './WelcomeContent';
import WelcomeNews from './WelcomeNews';
import WelcomePromo from './WelcomePromo';
import WelcomeRecommend from './WelcomeRecommend';
import WelcomeVerticalContent from './WelcomeVerticalContent';

const HomeContent: React.FC = () => {
    const dispatch = useDispatch();
    const lang = useLanguage();
    // const isMobile = useMediaQuery('(max-width: 760px)');

    const { data: blocks, refetch } = useGetPublicBlocksQuery();

    const [banners, setBanners] = useState<Banner[]>([]);
    const [news, setNews] = useState<News[]>([]);
    const [promo, setPromo] = useState<Promo[]>([]);
    const [polls, setPolls] = useState<Polls[]>([]);
    const [adverts, setAdverts] = useState<Adverts[]>([]);

    const [recommends, setRecommends] = useState<MediaProduct[]>([]);
    const [medias, setMedias] = useState<MediaUnit[]>([]);
    const [vmedias, setVMedias] = useState<MediaUnit[]>([]);
    const [tvs, setTVs] = useState<TVUnit[]>([]);
    const [products, setProducts] = useState<ProductUnit[]>([]);
    const [notifications, setNotifications] = useState<NotificationUnit[]>([]);

    useEffect(() => {
        refetch().unwrap()
            // FIX для кривого access токена который может остаться
            .catch((e) => {
                if (e.status === 401) {
                    dispatch(setCredentials({ user: '', account: '', accessToken: '', refreshToken: '' }));
                    refetch();
                }
            });
    }, [lang]);

    useEffect(() => {
        if (blocks?.results.length) {
            blocks.results.forEach((block) => {
                switch (block.label) {
                    case 'welcome-banners':
                        setBanners(block.items as Banner[]);
                        break;
                    case 'welcome-advertisements':
                        setAdverts(block.items as Adverts[]);
                        break;
                    case 'welcome-news':
                        setNews(block.items as News[]);
                        break;
                    case 'welcome-polls':
                        setPolls(block.items as Polls[]);
                        break;
                    case 'welcome-promo':
                        setPromo(block.items as Promo[]);
                        break;
                    case 'welcome-media':
                        setMedias((block.items as MediaProduct<MediaUnit>[]).map((item) => ({ ...item.product })));
                        break;
                    case 'welcome-vertical-media':
                        setVMedias((block.items as MediaProduct<MediaUnit>[]).map((item) => ({ ...item.product })));
                        break;
                    case 'welcome-tv':
                        setTVs((block.items as MediaProduct<TVUnit>[]).map((item) => ({ ...item.product })));
                        break;
                    case 'welcome-products':
                        setProducts((block.items as MediaProduct<ProductUnit>[]).map((item) => ({ ...item.product })));
                        break;
                    case 'welcome-recommends':
                        setRecommends((block.items as MediaProduct[]));
                        break;
                    case 'welcome-notifications':
                        setNotifications(block.items as NotificationUnit[]);
                        break;
                    default:
                        break;
                }
            })
        }
    }, [blocks?.results]);

    return (
        <>
            <WelcomeAuth />

            {(sessionStorage.text && lang === 'ru') ? <div style={{ margin: '0 14px 20px', lineHeight: '20px' }} dangerouslySetInnerHTML={{ __html: sessionStorage.text }} /> : null}

            <WelcomeBanners banners={banners} />

            <WelcomePromo promo={promo} />

            <WelcomeRecommend items={recommends} />

            <WelcomeNews news={news} notify={notifications} />

            {/* <section className="welcome-promo-container _wide _mid-section">
                <a href={'https://www.msk-ix.ru/medialogistika/'} target="_blank">
                    <img src={isMobile ? PromoSquare : PromoFlat} loading="lazy" alt="" className="welcome-live__ad-placeholder" style={{ borderRadius: '14px' }} />
                </a>
            </section> */}
            <WelcomeAdBanner label="advertising-banners-1" />

            <WelcomeVerticalContent items={vmedias} title={t('Vertical content')} />

            <WelcomeContent type="media" items={medias} title={t('Video content')} />
            <WelcomeContent type="tv" items={tvs} title={t('TV channels')} />
            <WelcomeContent type="product" items={products} title={t('content:SERVICES')} />

            {/* <WelcomeLive polls={polls} adverts={adverts} /> */}
            <WelcomeBottom polls={polls} adverts={adverts} />

            <WelcomeAdBanner label="advertising-banners-2" />

            {(sessionStorage.text2 && lang === 'ru') ? <div style={{ margin: '0 14px 10px', lineHeight: '20px' }} dangerouslySetInnerHTML={{ __html: sessionStorage.text2 }} /> : null}
        </>
    );
};

export default HomeContent;